import cornerstoneTools from 'cornerstone-tools';
import Formatter from '../formatter';
import cornerstone from 'cornerstone-core';

const TextMarkerTool = cornerstoneTools.TextMarkerTool;
const draw = cornerstoneTools.importInternal('drawing/draw');
const setShadow = cornerstoneTools.importInternal('drawing/setShadow');
const drawTextBox = cornerstoneTools.importInternal('drawing/drawTextBox');
const getNewContext = cornerstoneTools.import('drawing/getNewContext');

export default class TextMarkerToolEyonix extends TextMarkerTool {

    constructor(props = {}) {
        super(props);
    }

    createNewMeasurement(eventData) {
        const config = this.configuration;

        if (!config.current) {
            return;
        }

        // Create the measurement data for this tool with the end handle activated
        const measurementData = {
            visible: true,
            active: true,
            text: config.current,
            color: undefined,
            fontSize: undefined,
            who: undefined,
            when: undefined,
            whenStr: undefined,
            invalidated: true,
            handles: {
                end: {
                    x: eventData.currentPoints.image.x,
                    y: eventData.currentPoints.image.y,
                    highlight: true,
                    active: true,
                    hasBoundingBox: true,
                },
            },
        };

        // Create a rectangle representing the image
        const imageRect = {
            left: 0,
            top: 0,
            width: eventData.image.width,
            height: eventData.image.height,
        };

        // Check if the current handle is outside the image,
        // If it is, prevent the handle creation
        if (
            !cornerstoneTools.external.cornerstoneMath.point.insideRect(
                measurementData.handles.end,
                imageRect
            )
        ) {
            return;
        }

        // Update the current marker for the next marker
        let currentIndex = config.markers.indexOf(config.current);

        const increment = config.ascending ? 1 : -1;

        currentIndex += increment;

        if (currentIndex >= config.markers.length) {
            currentIndex = config.loop ? 0 : -1;
        } else if (currentIndex < 0) {
            currentIndex = config.loop ? config.markers.length : -1;
        }

        config.current = config.markers[currentIndex];

        return measurementData;
    }
    renderToolData(evt) {
        const eventData = evt.detail;
        const config = this.configuration;
        const viewport = cornerstone.getViewport(eventData.element);
        // If we have no toolData for this element, return immediately as there is nothing to do
        const toolData = cornerstoneTools.getToolState(eventData.element, this.name);

        if (!toolData) {
            return;
        }

        // We have tool data for this element - iterate over each one and draw it
        const context = getNewContext(eventData.canvasContext.canvas);

        for (let i = 0; i < toolData.data.length; i++) {
            const data = toolData.data[i];

            if (data.visible === false) {
                continue;
            }

            //const color = toolColors.getColorIfActive(data);

            const color = cornerstoneTools.toolColors.getColorIfActive(data);

            data.color = data.color || cornerstoneTools.toolColors.getToolColor(data);

            let initFontSize = cornerstoneTools.textStyle.getFontSize();

            data.fontSize = data.fontSize !== undefined? data.fontSize : cornerstoneTools.textStyle.getFontSize();

            cornerstoneTools.textStyle.setFont(`${data.fontSize * viewport.scale}px Roboto`);
            cornerstoneTools.textStyle.setFontSize(data.fontSize * viewport.scale);

            if(data.invalidated && (data.who !== this.initialConfiguration.user || data.when !== new Date().toLocaleString())) {
                data.who = this.initialConfiguration.user;
                data.when = new Date().toLocaleString();
                if(this.initialConfiguration.momentLib && this.initialConfiguration.defaultDateTimeFormat) {
                    data.whenStr = this.initialConfiguration.momentLib().format(this.initialConfiguration.defaultDateTimeFormat);
                } else {
                    data.whenStr = new Date().toLocaleString();
                }
            }

            draw(context, context => {
                setShadow(context, config);

                const textCoords = cornerstoneTools.external.cornerstone.pixelToCanvas(
                    eventData.element,
                    data.handles.end
                );

                const options = {
                    centering: {
                        x: true,
                        y: true,
                    },
                };

                let textRows = [];
                if(data.text) textRows = Formatter.fragmentCanvasText(context, data.text, 250);

                data.handles.end.boundingBox = drawTextBox(
                    context,
                    textRows,
                    textCoords.x,
                    textCoords.y - 10,
                    color,
                    options
                );

                const tooltipText =  `${data.who} (${data.whenStr})` ;

                if((data.active || this.options.showUser) && data.who) {
                  drawTextBox(
                        context,
                        tooltipText,
                        textCoords.x,
                        textCoords.y + (data.handles.end.boundingBox.height/2) + 10,
                        "white",
                        options
                    );
                }

                data.invalidated = false;
            });
            cornerstoneTools.textStyle.setFontSize(initFontSize);
            cornerstoneTools.textStyle.setFont(`${initFontSize}px Roboto`);
        }

    }

}